/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsList } from "../funcs/agentsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ManagedAgent } from "../models/components/managedagent.js";
import {
  ListAgentsRequest,
  ListAgentsSecurity,
} from "../models/operations/listagents.js";
import { unwrapAsync } from "../types/fp.js";
export type AgentsQueryData = Array<ManagedAgent>;

export function prefetchAgents(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListAgentsRequest | undefined,
  security?: ListAgentsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAgentsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAgentsQuery(
  client$: GramCore,
  request?: ListAgentsRequest | undefined,
  security?: ListAgentsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<AgentsQueryData>;
} {
  return {
    queryKey: queryKeyAgents({ gramSession: request?.gramSession }),
    queryFn: async function agentsQueryFn(ctx): Promise<AgentsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(agentsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAgents(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "agents", "list", parameters];
}
